import React from 'react';

import type { StickerColor, StickerShape } from '../../../../../types/dontgiftguide';
import { BaubleSticker } from '../BaubleSticker/BaubleSticker';
import { BottleSticker } from '../BottleSticker/BottleSticker';
import { ChocolateSticker } from '../ChocolateSticker/ChocolateSticker';
import { CircleSticker } from '../CircleSticker/CircleSticker';
import { OvalSticker } from '../OvalSticker/OvalSticker';
import { PotSticker } from '../PotSticker/PotSticker';
import { SoapSticker } from '../SoapSticker/SoapSticker';
import { SockSticker } from '../SockSticker/SockSticker';

export interface StickerProps {
  shape: StickerShape;
  color: StickerColor;
  content: string;
}

export const Sticker = ({ shape, color, content }: StickerProps) => {
  switch (shape) {
    case 'oval':
      return <OvalSticker color={color} content={content} />;
    case 'circle':
      return <CircleSticker color={color} content={content} />;
    case 'sock':
      return <SockSticker content={content} />;
    case 'soap':
      return <SoapSticker content={content} />;
    case 'chocolate':
      return <ChocolateSticker content={content} />;
    case 'pot':
      return <PotSticker content={content} />;
    case 'bauble':
      return <BaubleSticker content={content} />;
    case 'bottle':
      return <BottleSticker content={content} />;
    default:
      console.error(`Unsupported sticker shape: ${shape}`);
      return null;
  }
};
